import { render, staticRenderFns } from "./UserSearchResultOverview.vue?vue&type=template&id=d933391c&scoped=true"
import script from "./UserSearchResultOverview.vue?vue&type=script&lang=ts"
export * from "./UserSearchResultOverview.vue?vue&type=script&lang=ts"
import style0 from "./UserSearchResultOverview.vue?vue&type=style&index=0&id=d933391c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d933391c",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/user-search-result-overview.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2FUserSearchResultOverview.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports